module.exports = __webpack_public_path__ + "img/nespresso.b0e913c3.png";